import { render, staticRenderFns } from "./OpenAccount.vue?vue&type=template&id=f673493e&scoped=true&"
import script from "./OpenAccount.vue?vue&type=script&lang=js&"
export * from "./OpenAccount.vue?vue&type=script&lang=js&"
import style0 from "./OpenAccount.vue?vue&type=style&index=0&id=f673493e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f673493e",
  null
  
)

export default component.exports